import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CallClearCart, chain } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { dispatchDeleteProduct } from "@store/Services/AnalyticsService";

addToChainBefore(chain, CallClearCart, props => {
    const state = props.getState();
    const cart = getCartState(state, props.apiParameter.cartId).value;
    if (cart) {
        dispatchDeleteProduct(cart.cartLines as CartLineModel[]);
    }
});
